module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/electric-guitars-8c1c730d5966ffb3343b1886a3734eb7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/electric-guitars.svg
// module id = FVit
// module chunks = 24